import React from 'react';
import { Card, Col, Row, Table } from 'react-bootstrap';
import TextSkeleton from '../TextSkeleton';
import { CardSkeleton } from '../Loader';

export function ProfitabilityByServiceTypeSkeleton() {
  return (
    <Row>
      {[0, 1, 2].map(i => (
        <Col key={i} xs={12} lg={4} className="mb-3">
          <Card className="shadow-sm rounded h-100" style={{ border: '1px solid #e5e7ea' }}>
            <Card.Body className="p-3">
              <CardSkeleton isRect={true} />
            </Card.Body>
          </Card>
        </Col>
      ))}
    </Row>
  );
}

const CLIENT_TABLE_HEADERS = [
  'Client',
  'Files',
  'Services',
  'Paid',
  'Cancelled',
  'Processing Fees',
  'HC Lost',
  'Operating Result',
  'Working Capital'
];

const CLIENT_SKELETON_CELL_WIDTHS = [120, 40, 44, 36, 44, 72, 56, 64, 64];

export function ProfitabilityByClientTableSkeleton() {
  return (
    <Table borderless className="mb-0 smallFont">
      <thead>
        <tr className="text-muted border-bottom" style={{ borderColor: '#eef2f7' }}>
          {CLIENT_TABLE_HEADERS.map(label => (
            <th
              key={label}
              className={`font-weight-semibold tinyFont pb-2${label === 'Client' ? '' : ' text-right'}`}
            >
              {label}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {[0, 1, 2, 3, 4, 5].map(row => (
          <tr key={`client-skel-${row}`} style={{ borderTop: '1px solid #eef2f7' }}>
            {CLIENT_SKELETON_CELL_WIDTHS.map((w, col) => (
              <td key={col} className={`py-2${col === 0 ? '' : ' text-right'}`}>
                {col === 0 ? (
                  <TextSkeleton lines={1} lineWidths={[w]} lineHeight={8} />
                ) : (
                  <div className="d-flex justify-content-end">
                    <TextSkeleton lines={1} lineWidths={[w]} lineHeight={8} />
                  </div>
                )}
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </Table>
  );
}

const WC_TABLE_HEADERS = [
  'Service Type',
  'Unpaid Count',
  'Accounts Receivable',
  'Working Capital (HC)',
  'Pending Fees'
];

const WC_SKELETON_ROW_WIDTHS = [
  [88, 36, 80, 80, 72],
  [88, 36, 80, 80, 72],
  [88, 36, 80, 80, 72],
  [88, 36, 80, 80, 72],
  [48, 36, 80, 80, 72]
];

export function WorkingCapitalSkeleton() {
  return (
    <>
      <Row className="mb-3">
        {[0, 1, 2].map(i => (
          <Col key={i} xs={12} lg={4} className="mb-3 mb-lg-0">
            <Card className="rounded shadow-sm h-100" style={{ border: '1px solid #e5e7ea' }}>
              <Card.Body className="py-3 px-4 text-center">
                <div className="d-flex justify-content-center mb-2">
                  <TextSkeleton lines={1} lineWidths={[160]} lineHeight={8} />
                </div>
                <div className="d-flex justify-content-center">
                  <TextSkeleton lines={1} lineWidths={[100]} lineHeight={14} />
                </div>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
      <div className="table-responsive">
        <Table borderless className="mb-0 smallFont">
          <thead>
            <tr className="text-muted">
              {WC_TABLE_HEADERS.map(label => (
                <th
                  key={label}
                  className={`font-weight-semibold tinyFont pb-3${label === 'Service Type' ? '' : ' text-right'}`}
                >
                  {label}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {WC_SKELETON_ROW_WIDTHS.map((widths, row) => (
              <tr key={`wc-skel-${row}`} style={{ borderTop: '1px solid #eef2f7' }}>
                {widths.map((w, col) => (
                  <td key={col} className={`py-2${col === 0 ? '' : ' text-right'}`}>
                    {col === 0 ? (
                      <TextSkeleton lines={1} lineWidths={[w]} lineHeight={8} />
                    ) : (
                      <div className="d-flex justify-content-end">
                        <TextSkeleton lines={1} lineWidths={[w]} lineHeight={8} />
                      </div>
                    )}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </Table>
      </div>
    </>
  );
}

const RF_TABLE_HEADERS = ['Month', 'Services', 'Expected Revenue', 'Est. Fees (Earnings)', 'Est. Hard Costs (WC)'];

const RF_SKELETON_FIRST_COL_WIDTHS = [56, 56, 56, 40];

const RF_SKELETON_NUMERIC_WIDTHS = [36, 88, 72, 88];

export function RevenueForecastTableSkeleton() {
  return (
    <Table borderless className="mb-0 smallFont">
      <thead>
        <tr className="text-muted">
          {RF_TABLE_HEADERS.map(label => (
            <th
              key={label}
              className={`font-weight-semibold tinyFont pb-3${label === 'Month' ? '' : ' text-right'}`}
            >
              {label}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {RF_SKELETON_FIRST_COL_WIDTHS.map((firstW, row) => (
          <tr key={`rf-skel-${row}`} style={{ borderTop: '1px solid #eef2f7' }}>
            <td className="py-2">
              <TextSkeleton lines={1} lineWidths={[firstW]} lineHeight={8} />
            </td>
            {RF_SKELETON_NUMERIC_WIDTHS.map((w, col) => (
              <td key={col} className="py-2 text-right">
                <div className="d-flex justify-content-end">
                  <TextSkeleton lines={1} lineWidths={[w]} lineHeight={8} />
                </div>
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </Table>
  );
}
